import { t } from '../i18n/helpers';

export const getPasswordStrength = (password) => {
  if (!password) return { score: 0, label: '', color: 'bg-zinc-700' };

  let score = 0;
  if (password.length >= 8) score++;
  if (password.length >= 12) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;

  if (score <= 2) return { score: 1, label: t('password.weak'), color: 'bg-red-500' };
  if (score <= 3) return { score: 2, label: t('password.fair'), color: 'bg-amber-500' };
  if (score <= 4) return { score: 3, label: t('password.good'), color: 'bg-emerald-500' };
  return { score: 4, label: t('password.strong'), color: 'bg-emerald-400' };
};
